import React, { Suspense } from 'react'
import Demo from '@/views/components/pageLoading'
import { searchQuery, getLongLang } from '@/utils/common'
import { setLanguage } from '@/locale'
import store from '@/store'

const FormSetting = React.lazy(() => import('@/views/form/formSetting'))
const FormAddView = React.lazy(() => import('@/views/form/formAddView'))
const FormEditView = React.lazy(() => import('@/views/form/formEditView'))
const FormSubmitSuccess = React.lazy(() => import('@/views/form/formSubmitSuccess'))
const Callback = React.lazy(() => import('@/views/login/callback'))
const Silent = React.lazy(() => import('@/views/login/silent'))
const ScanPage = React.lazy(() => import('@/views/scan'))
const LotteryRecordUnAssociated = React.lazy(() => import('@/views/form/lotteryRecordUnAssociated'))
const SignQrCode = React.lazy(() => import('@/views/form/signQrCode'))

const routes = [
  {
    path: '/formrender',
    id: 'route',
    loader: async ({ request }) => {
      const query = searchQuery(request.url)
      const lang = getLongLang(query.lang)
      setLanguage(lang)
      store.dispatch({ type: 'setLanguage', data: lang })
      return {}
    },
    children: [
      {
        path: 'callback',
        id: 'callback',
        element: (
          <Suspense fallback={<Demo />}>
            <Callback />
          </Suspense>
        )
      },
      {
        path: 'silent',
        element: (
          <Suspense fallback={<Demo />}>
            <Silent />
          </Suspense>
        )
      },
      {
        path: 'lotteryRecord',
        element: (
          <Suspense fallback={<Demo />}>
            <LotteryRecordUnAssociated />
          </Suspense>
        )
      },
      {
        path: 'signQrCode',
        handle: {
          title: '签到码'
        },
        element: (
          <Suspense fallback={<Demo />}>
            <SignQrCode />
          </Suspense>
        )
      },
      {
        path: 'formSetting/:id/:userId',
        id: 'formSetting',
        element: (
          <Suspense fallback={<Demo />}>
            <FormSetting />
          </Suspense>
        )
      },
      {
        path: 'formView/:id',
        id: 'formAddView',
        element: (
          <Suspense fallback={<Demo />}>
            <FormAddView />
          </Suspense>
        )
      },
      {
        path: 'formView/:id/:rId/:userId',
        element: (
          <Suspense fallback={<Demo />}>
            <FormEditView />
          </Suspense>
        )
      },
      {
        path: 'formView/formSubmitSuccess',
        element: (
          <Suspense fallback={<Demo />}>
            <FormSubmitSuccess />
          </Suspense>
        )
      },
      {
        path: 'scan/*',
        element: (
          <Suspense fallback={<Demo />}>
            <ScanPage />
          </Suspense>
        )
      }
    ]
  },
  { path: '*', element: <div>not found</div> }
]

export default routes
